/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 1a1a5dde38749512311b89a00e3e5783 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HomepageEsQueryVariables = {
    country: string;
};
export type HomepageEsQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"BaseLayout_viewer" | "ProductSelector_viewer">;
    };
};
export type HomepageEsQuery = {
    readonly response: HomepageEsQueryResponse;
    readonly variables: HomepageEsQueryVariables;
};



/*
query HomepageEsQuery(
  $country: String!
) {
  viewer {
    ...BaseLayout_viewer_1vRKRZ
    ...ProductSelector_viewer_1vRKRZ
  }
}

fragment BaseLayout_viewer_1vRKRZ on Viewer {
  ...SessionLayout_viewer
  ...Header_viewer_1vRKRZ
  ...Footer_viewer_1vRKRZ
}

fragment DesktopHeader_categories on WebsiteMarketingProductCategory {
  name
  products {
    ...DesktopSubmenu_products
  }
}

fragment DesktopSubmenuPlaceholder_product on WebsiteMarketingProduct {
  ...ProductTheme_product
  name
  code
}

fragment DesktopSubmenuProduct_product on WebsiteMarketingProduct {
  name
  code
  shortDescription
}

fragment DesktopSubmenu_products on WebsiteMarketingProduct {
  name
  isComingSoon
  ...DesktopSubmenuProduct_product
  ...DesktopSubmenuPlaceholder_product
}

fragment FooterCountryPicker_viewer on Viewer {
  countries: visibleCountriesByPlatform(platform: WEBSITE) {
    id
    countryAlpha2
    displayName
  }
}

fragment Footer_viewer_1vRKRZ on Viewer {
  ...FooterCountryPicker_viewer
  countryByCode(code: $country) {
    websiteNavigationSections {
      __typename
      ...MenuSections_sections
    }
    id
  }
}

fragment Header_viewer_1vRKRZ on Viewer {
  countryByCode(code: $country) {
    websiteMarketingProductCategories {
      ...DesktopHeader_categories
    }
    websiteNavigationSections {
      __typename
      ...MenuSections_sections
    }
    id
  }
}

fragment MenuSections_sections on WebsiteNavigationSection {
  __typename
  ... on MarketingProductWebsiteNavigationSection {
    productCategory {
      name
      products {
        name
        code
        isComingSoon
      }
    }
  }
  ... on SimpleWebsiteNavigationSection {
    name
    links {
      title
      href
      label
    }
  }
}

fragment ProductSelector_viewer_1vRKRZ on Viewer {
  country: countryByCode(code: $country) {
    productCategories: websiteMarketingProductCategories {
      products {
        isComingSoon
        code
        name
        shortName
        path
      }
    }
    id
  }
}

fragment ProductTheme_product on WebsiteMarketingProduct {
  color
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "country",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "country"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isComingSoon",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "HomepageEsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BaseLayout_viewer",
            "args": (v1/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "ProductSelector_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomepageEsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "session",
            "storageKey": null,
            "args": null,
            "concreteType": "Session",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "countryByCode",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "Country",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "websiteMarketingProductCategories",
                "storageKey": null,
                "args": null,
                "concreteType": "WebsiteMarketingProductCategory",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WebsiteMarketingProduct",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shortDescription",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "color",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "websiteNavigationSections",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "MarketingProductWebsiteNavigationSection",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "productCategory",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "WebsiteMarketingProductCategory",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "products",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "WebsiteMarketingProduct",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "type": "SimpleWebsiteNavigationSection",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "links",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SimpleWebsiteNavigationLink",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "href",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "countries",
            "name": "visibleCountriesByPlatform",
            "storageKey": "visibleCountriesByPlatform(platform:\"WEBSITE\")",
            "args": [
              {
                "kind": "Literal",
                "name": "platform",
                "value": "WEBSITE"
              }
            ],
            "concreteType": "Country",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "countryAlpha2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "country",
            "name": "countryByCode",
            "storageKey": null,
            "args": (v3/*: any*/),
            "concreteType": "Country",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "productCategories",
                "name": "websiteMarketingProductCategories",
                "storageKey": null,
                "args": null,
                "concreteType": "WebsiteMarketingProductCategory",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WebsiteMarketingProduct",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "shortName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "path",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "HomepageEsQuery",
    "id": null,
    "text": "query HomepageEsQuery(\n  $country: String!\n) {\n  viewer {\n    ...BaseLayout_viewer_1vRKRZ\n    ...ProductSelector_viewer_1vRKRZ\n  }\n}\n\nfragment BaseLayout_viewer_1vRKRZ on Viewer {\n  ...SessionLayout_viewer\n  ...Header_viewer_1vRKRZ\n  ...Footer_viewer_1vRKRZ\n}\n\nfragment DesktopHeader_categories on WebsiteMarketingProductCategory {\n  name\n  products {\n    ...DesktopSubmenu_products\n  }\n}\n\nfragment DesktopSubmenuPlaceholder_product on WebsiteMarketingProduct {\n  ...ProductTheme_product\n  name\n  code\n}\n\nfragment DesktopSubmenuProduct_product on WebsiteMarketingProduct {\n  name\n  code\n  shortDescription\n}\n\nfragment DesktopSubmenu_products on WebsiteMarketingProduct {\n  name\n  isComingSoon\n  ...DesktopSubmenuProduct_product\n  ...DesktopSubmenuPlaceholder_product\n}\n\nfragment FooterCountryPicker_viewer on Viewer {\n  countries: visibleCountriesByPlatform(platform: WEBSITE) {\n    id\n    countryAlpha2\n    displayName\n  }\n}\n\nfragment Footer_viewer_1vRKRZ on Viewer {\n  ...FooterCountryPicker_viewer\n  countryByCode(code: $country) {\n    websiteNavigationSections {\n      __typename\n      ...MenuSections_sections\n    }\n    id\n  }\n}\n\nfragment Header_viewer_1vRKRZ on Viewer {\n  countryByCode(code: $country) {\n    websiteMarketingProductCategories {\n      ...DesktopHeader_categories\n    }\n    websiteNavigationSections {\n      __typename\n      ...MenuSections_sections\n    }\n    id\n  }\n}\n\nfragment MenuSections_sections on WebsiteNavigationSection {\n  __typename\n  ... on MarketingProductWebsiteNavigationSection {\n    productCategory {\n      name\n      products {\n        name\n        code\n        isComingSoon\n      }\n    }\n  }\n  ... on SimpleWebsiteNavigationSection {\n    name\n    links {\n      title\n      href\n      label\n    }\n  }\n}\n\nfragment ProductSelector_viewer_1vRKRZ on Viewer {\n  country: countryByCode(code: $country) {\n    productCategories: websiteMarketingProductCategories {\n      products {\n        isComingSoon\n        code\n        name\n        shortName\n        path\n      }\n    }\n    id\n  }\n}\n\nfragment ProductTheme_product on WebsiteMarketingProduct {\n  color\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '67b7a00a56f0eb95a7bc050037f08c25';
export default node;
